import React from 'react';

import { useDetectClickOutsideElement } from '../../../hooks/useDetectClickOutsideElement';

const ModalFailPayment = ({ isModalFailPaymentActive, closeModalFailPayment, creditcard }) => {
  if (!isModalFailPaymentActive) return <div />;

  const { containerRef } = useDetectClickOutsideElement({ onClickOutside: closeModalFailPayment });

  return (
    <div className="comp_modalpagamento mobile-roof">
      <div className="modalcontents mobile-modal failPaymentModal" ref={containerRef}>
        <div className="contents">
          <div className="modaltop">
            <div className="title">Erro ao finalizar o seu pagamento</div>
            <div onClick={closeModalFailPayment} className="close-btn">
              <img src="/assets/images/icons/close.svg" alt="botão de fechar janela" style={{ height: '14px' }}  />
            </div>
          </div>
          <div className="modalmiddle modalMiddlefailPayment">
            <img src='/assets/images/ic-fail-payment.svg' alt="" className='fail-payment-icon' style={{width: '243.975px', height: '170px'}} />
            <h2>
                Não conseguimos processar o pagamento do seu seguro viagem.
            </h2>

            <div className='modalMiddleFailPaymentText'>
                <div className='flex-start-column'>
                    <span>
                        Revise seus dados de pagamento e tente finalizar novamente.
                    </span>
                    <span>
                        Confira os motivos mais comuns para isso acontecer:
                    </span>
                </div>

                <ul className='flex-start-column ulFailPayment'>
                    <li>Algum dado foi digitado errado (número do cartão, data de vencimento, código de segurança);</li>
                    <li>
                        Limite de crédito indisponível no cartão;
                    </li>
                    <li>
                        Limite de transações do cartão virtual;
                    </li>
                    <li>
                        Uso de um cartão de débito (aceitamos apenas crédito).
                    </li>
                    <li>
                        Bloqueio de segurança pela operadora do cartão;
                    </li>

                </ul>

                <div className='flex-start-column'>
                    <span>
                        Em caso de dúvidas, <strong>entre em contato com a operadora do seu cartão</strong> (geralmente o número de telefone fica no verso do cartão) e finalize a compra novamente.
                    </span>
                </div>
            </div>



            <div>
                <button
                    className="btn"
                    onClick={closeModalFailPayment}
                    data-cy="close-modal-fail-payment"
                >
                    Revisar pagamento
                </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ModalFailPayment;



// WEBPACK FOOTER //
// ./src/components/purchase/modal_fail_payment/ModalFailPayment.jsx